<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 style="margin-bottom: 0px;">SOLICITUDES</h5>
      <h6 style="margin-top: 0px;">Gestión de Solicitudes Públicas en los Juzgados del Poder Judicial en el Estado</h6>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top: 0px">
        <div class="area">
          <div class="form-group 3" id="Codigo_div">
            <label>Código:</label>
            <input type="Number" class="form-control" v-model="BusquedaCodigo" v-on:keyup='DetectarEnter' />
          </div>
          <div id="BotonBusqueda_div" class="text-right">
            <button class="btn btn-sm btn-dark" @click='BusquedaDocumento()'>Buscar Documento</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top: 0px">
        <div class="area" v-if="this.ShowInfoDocumento==true" style="margin-top: 0px">
          <div>
            <h5>Documento</h5>
          </div>
          <div class="row align-items-center">
            <div class="form-group col-8" id="Area_div">
              <label>Área</label>
              <input type="text" class="form-control" v-model="Documento.Area.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="Materia_div">
              <label>Materia</label>
              <div v-if="Documento.Materia != null">
                <input type="text" class="form-control" v-model="Documento.Materia.Nombre" readonly />
              </div>
              <div v-else>
                <input type="text" class="form-control" readonly />
              </div>
            </div>

          </div>
          <div class="row align-items-center">
            <div class="form-group col-4" id="TipoDocumento_div">
              <label>Tipo de Documento</label>
              <input type="text" class="form-control" v-model="Documento.TipoDocumento.Nombre" readonly />
            </div>
            <div class="form-group col-4" id="Anio_div">
              <label>Año</label>

              <input type="text" class="form-control " v-model="Documento.Anio" readonly />
            </div>
            <div class="form-group col-4" id="Consecutivo_div">
              <label>Consecutivo</label>
              <input type="text" class="form-control" v-model="Documento.Consecutivo" readonly />
            </div>
          </div>
          <div id="Volumen_table" class="table-responsive">
            <h6>Volumenes</h6>
            <table class="table table-striped table-light table-hover">
              <thead class="thead-dark">
                <tr>
                  <th>No.</th>
                  <th>Fojas</th>
                  <th>Ubicación</th>
                  <th>Estatus</th>
                  <th>Contenido</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-if="volumenesJuzgado.length <= 0">
                  <td colspan="12" class="text-center">No hay registro del Volumen</td>
                </tr>
                <tr v-else v-for="detalle in volumenesJuzgado" :key="detalle.VolumenId">
                  <td width="30">{{detalle.NumVolumen}}</td>
                  <td width="30">{{detalle.Fojas}}</td>
                  <td width="100">{{detalle.Area.Nombre}}

                  <td width="100" v-if="detalle.MovimientoVolumen == null">
                    Sin Movimiento
                  </td>
                  <td width="100" v-else>
                    <span v-if="detalle.MovimientoVolumen.AreaQueRecibe != null" class="badge badge-pill badge-success text-center">Disponible al Público</span>
                    <span v-else class="badge badge-pill badge-warning text-center">En el Público</span>
                  </td>
                  <td width="300" v-html="DesglosaContenido(detalle)">
                   
                  </td>
                  
                  <td width="50" v-if="detalle.MovimientoVolumen != null" class="text-center" style="float: center;">
                    <input type="checkbox" v-model="ListaVolumenes" v-bind:value="detalle.VolumenId"/>
                  </td>
                </tr>
              </tbody>
            </table>
            <h6 v-if="incidentesJuzgado.length>0">Incidentes</h6>
            <table class="table table-striped table-light table-hover" v-if="incidentesJuzgado.length>0">
              <thead class="thead-dark">
                <tr>
                  <th>No.</th>
                  <th>Tipo</th>
                  <th>Ubicación</th>
                  <th>Estatus</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="text-dark">
                
                <tr v-for="detalle in incidentesJuzgado" :key="detalle.IncidenteId">
                  <td width="50" >{{detalle.NumeroIncidente}}</td>
                  <td width="200">{{detalle.TipoIncidente}}</td>
                  <td width="200">{{detalle.Area.Nombre}}

                  <td width="150" v-if="detalle.MovimientoIncidente == null">
                    Sin Movimiento
                  </td>
                  <td width="150" v-else>
                    <span v-if="detalle.MovimientoIncidente.AreaQueRecibe != null" class="badge badge-pill badge-success text-center">Disponible al Público</span>
                    <span v-else class="badge badge-pill badge-warning text-center">En el Público</span>
                  </td>
                  <td width="100"></td>
                  <td width="50" v-if="detalle.MovimientoIncidente != null" class="text-center" style="float: center;">
                    <input type="checkbox" v-model="ListaIncidentes" v-bind:value="detalle.IncidenteId"/>
                  </td>
                </tr>
              </tbody>
            </table>

            <h6 v-if="terceriasJuzgado.length>0">Tercerías</h6>
            <table class="table table-striped table-light table-hover" v-if="terceriasJuzgado.length>0">
              <thead class="thead-dark">
                <tr>
                  <th>No.</th>
                  <th>Tipo</th>
                  <th>Ubicación</th>
                  <th>Estatus</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="text-dark">
                
                <tr v-for="detalle in terceriasJuzgado" :key="detalle.TerceriaId">
                  <td width="50" >{{detalle.NumeroTerceria}}</td>
                  <td width="200">{{detalle.TipoTerceria}}</td>
                  <td width="200">{{detalle.Area.Nombre}}

                  <td width="150" v-if="detalle.MovimientoTerceria == null">
                    Sin Movimiento
                  </td>
                  <td width="150" v-else>
                    <span v-if="detalle.MovimientoTerceria.AreaQueRecibe != null" class="badge badge-pill badge-success text-center">Disponible al Público</span>
                    <span v-else class="badge badge-pill badge-warning text-center">En el Público</span>
                  </td>
                  <td width="100"></td>
                  <td width="50" v-if="detalle.MovimientoTerceria != null" class="text-center" style="float: center;">
                    <input type="checkbox" v-model="ListaTercerias" v-bind:value="detalle.TerceriaId"/>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="this.ListaVolumenes.length > 0 || this.ListaIncidentes.length>0 ||this.ListaTercerias.length>0" id="BotonBusqueda_div" class="text-right">
              <button class="btn btn-sm btn-dark" @click='Movimiento()'>Aceptar</button>
            </div>
          </div>
        </div>
        <div class="area" v-if="this.ListaDePublicos.length > 0">
          <div>
            <h5>Listado de Documentos Vigentes en el Público</h5>
          </div>
          <div id="Publicos_table" class="table-reponsive">
            <table class="table table-striped table-light table-hover">
              <thead class="thead-dark">
                <tr>
                  <th>Documento</th>
                  <th>Elemento</th>
                  <th>Ubicación</th>
                  <th>Estatus</th>
                  
                </tr>
              </thead>
              <tbody class="text-dark" v-for="lista in ListaDePublicos" :key="lista.InventarioDocumentoId">
                
                <tr  >
                  <td v-bind:rowspan="lista.Movimientos.length + 1">
                                  {{lista.TipoDocumento.Nombre}} {{lista.Anio}}/{{lista.Consecutivo}}</td >
                </tr>
                <tr v-for="detalles in lista.Movimientos" :key="detalles.MovimientoDocumentoId">
                  <td v-if="detalles.VolumenId!=null">Volumen No. :  {{detalles.Volumen.NumVolumen}}, Fojas : {{detalles.Volumen.Fojas}}</td>
                  <td v-else>Incidente No. : {{detalles.Incidente.NumeroIncidente}}, Tipo Incidente : {{detalles.Incidente.TipoIncidente}} </td>
                  <td v-if="detalles.VolumenId!=null">{{detalles.Volumen.Area.Nombre}}
                  <td v-else>{{detalles.Incidente.Area.Nombre}} 
                  <td v-if="detalles.AreaQueRecibe != null">
                    <span class="badge badge-pill badge-success text-center">Disponible al Público</span>
                  </td>
                  <td v-else>
                    <span class="badge badge-pill badge-warning text-center">En el Público</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'



export default {
    data(){
        return{
            BusquedaCodigo: "",
            Documento: {
                InventarioDocumentoId: "",
                Area: {},
                Materia: {},
                TipoDocumento: {},
                Año: "",
                Consecutivo: "",
                CodigoBarras: "",
                Fecha_Registro: null,
                TipoEstatusInventario: {}
            },
            Volumenes :[],
            Incidentes: [],
            Tercerias: [],
            ShowInfoDocumento : false,
            volumenesJuzgado :[],
            incidentesJuzgado:[],
            terceriasJuzgado:[],
            Etiqueta: "",
            ListaVolumenes: [],
            ListaIncidentes:[],
            ListaTercerias: [],
            SeleccionarTodos:false,
            ListaDePublicos: []
        }
    },
    methods: {
        BusquedaDocumento(){
            var peticion = {
                    "AreaId": -1,
                    "TipoDocumentoId": -1,
                    "Anio" : null,
                    "Consecutivo": null,
                    "Sufijo": null,
                    "CodigoBarras": this.BusquedaCodigo
                };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.BusquedaCodigo = "";
                    this.ShowInfoDocumento = false;
                 }
                else
                {
                    comun.SeEstaCargandoInformacion(false);
                    this.BusquedaCodigo = "";
                    this.Documento= respuesta.data.GetDocumento;
                    let UbicacionVolumen =Object;
                    let UbicacionIncidentes =Object;
                    let UbicacionTercerias = Object;
                    
                    this.Volumenes = respuesta.data.GetDocumento.Volumenes != null ? respuesta.data.GetDocumento.Volumenes : this.Volumenes = [] ;

                    this.Incidentes = respuesta.data.GetDocumento.Incidentes !=null ? respuesta.data.GetDocumento.Incidentes : this.Incidentes = [];
                    this.Tercerias = respuesta.data.GetDocumento.Tercerias !=null ? respuesta.data.GetDocumento.Tercerias : this.Tercerias =[];

                    //aqui analizamos areas de ubicacion de volumenes e incidentes
                    if(this.Volumenes.length > 0)
                    {
                      UbicacionVolumen = this.VerificarVolumenes(this.Documento.Area.AreaId);
                     
                      if(UbicacionVolumen.Volumenes.length>0)
                      {
                        this.ShowInfoDocumento = true;
                        this.volumenesJuzgado = UbicacionVolumen.Volumenes;
                         if(this.Incidentes.length > 0)
                          {
                            UbicacionIncidentes = this.VerificaIncidentes(this.Documento.Area.AreaId);
                            this.incidentesJuzgado = UbicacionIncidentes.Incidentes;
                          }
                          if(this.Tercerias.length > 0)
                          {
                            UbicacionTercerias = this.VerificaTercerias(this.Documento.Area.AreaId);
                            this.terceriasJuzgado = UbicacionTercerias.Tercerias;
                          }
                      }
                      else
                      {   
                          this.volumenesJuzgado = [];
                          if(this.Incidentes.length > 0)
                          {
                            UbicacionIncidentes = this.VerificaIncidentes(this.Documento.Area.AreaId);
                            if(UbicacionIncidentes.Incidentes.length>0)
                              {
                                this.ShowInfoDocumento = true;
                                this.incidentesJuzgado = UbicacionIncidentes.Incidentes;                            
                              }
                          }
                          else
                              {
                                this.incidentesEnJuzgado = [];
                                this.ShowInfoDocumento = false;
                                comun.mensajeDeAlerta("Este documento actualmente no tiene ubicación física en esta Área" 
                                + "<br/>Ubicación Actual: " + UbicacionVolumen.Ubicacion , null, null);
                              }
                      }
                      
                    };
                    
                }
               
            })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                this.BusquedaCodigo = "";
            })

        },
        DetectarEnter: function(e){
            if (e.keyCode==13)
            {
                if(this.BusquedaCodigo != null || this.BusquedaCodigo != undefined)
                {
                    if(this.BusquedaCodigo.length==13)
                    {
                        this.BusquedaDocumento();
                    }
                    else
                    {
                        comun.mensajeDeAlerta("Error en Código de Barras", null, null);
                    }
                }
                else
                {
                    comun.mensajeDeAlerta("Error en Código de Barras", null, null);
                }

            }
        },
        Movimiento(){
           let ListaVolumen=[];
           let ListaIncidentes = [];

           ListaVolumen= this.SeleccionarVolumenes();
           ListaIncidentes = this.SeleccionarIncidentes();
           console.log(ListaIncidentes);
          
           let MovimientosDocumentos = []
            if(ListaVolumen.length>0)
            {
                $.each(ListaVolumen, function(indice, volumen) {

                    if (volumen.MovimientoVolumen.UsuarioQuienRecibe != null)
                    {
                        MovimientosDocumentos.push({
                            VolumenId : volumen.VolumenId,
                            IncidenteId : null,
                            TiposMovimientos: {"TipoMovimientoId": 4},
                            UsuarioQuienPresta: {"IdUsuario" : volumen.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario},
                            UsuarioQuienRecibe : {"IdUsuario": null},
                            AreaQuePresta :{"AreaId" : volumen.MovimientoVolumen.AreaQueRecibe.AreaId},
                            AreaQueRecibe :{"AreaId": null},
                            SolicitudDocumentoId: volumen.MovimientoVolumen.SolicitudDocumentoId,
                            Observaciones: "Préstamo al Público",

                        });
                    }
                    else{
                        MovimientosDocumentos.push({
                            VolumenId : volumen.VolumenId,
                            IncidenteId : null,
                            TiposMovimientos: {"TipoMovimientoId": 2},
                            UsuarioQuienPresta: {"IdUsuario": null},
                            UsuarioQuienRecibe: {"IdUsuario" : volumen.MovimientoVolumen.UsuarioQuienPresta.IdUsuario},
                            AreaQuePresta: {"AreaId": null},
                            AreaQueRecibe : {"AreaId" : volumen.MovimientoVolumen.AreaQuePresta.AreaId},
                            SolicitudDocumentoId: volumen.MovimientoVolumen.SolicitudDocumentoId,
                            Observaciones: "Devolución del Público",

                        });
                    }
                });
            }
            
            if(ListaIncidentes.length>0)
            {
                $.each(ListaIncidentes, function(indice, incidente) {

                    if (incidente.MovimientoIncidente.UsuarioQuienRecibe != null)
                    {
                        MovimientosDocumentos.push({
                            VolumenId : null,
                            IncidenteId : incidente.IncidenteId,
                            TiposMovimientos: {"TipoMovimientoId": 4},
                            UsuarioQuienPresta: {"IdUsuario" : incidente.MovimientoIncidente.UsuarioQuienRecibe.IdUsuario},
                            UsuarioQuienRecibe : {"IdUsuario": null},
                            AreaQuePresta :{"AreaId" : incidente.MovimientoIncidente.AreaQueRecibe.AreaId},
                            AreaQueRecibe :{"AreaId": null},
                            SolicitudDocumentoId: incidente.MovimientoIncidente.SolicitudDocumentoId,
                            Observaciones: "Préstamo al Público",

                        });
                    }
                    else{
                        MovimientosDocumentos.push({
                            VolumenId : null,
                            IncidenteId : incidente.IncidenteId,
                            TiposMovimientos: {"TipoMovimientoId": 2},
                            UsuarioQuienPresta: {"IdUsuario": null},
                            UsuarioQuienRecibe: {"IdUsuario" : incidente.MovimientoIncidente.UsuarioQuienPresta.IdUsuario},
                            AreaQuePresta: {"AreaId": null},
                            AreaQueRecibe : {"AreaId" : incidente.MovimientoIncidente.AreaQuePresta.AreaId},
                            SolicitudDocumentoId: incidente.MovimientoIncidente.SolicitudDocumentoId,
                            Observaciones: "Devolución del Público",

                        });
                    }
                });
            }

            if(ListaVolumen.length==0 && ListaIncidentes.length==0)
            {
              comun.mensajeDeAlerta("Seleccione los Volumenes deseados para prestamo al Público o devolución", null, null);
            }
            else
            {
              
              var peticion = {
              "MovimientosDocumentos" : MovimientosDocumentos};
              console.log(peticion);
              axios.post(api.conexion + api.ArchivoJudicial.NuevaSolicitudPublicaJuzgado, peticion,
              comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then( respuesta => {
                  if(respuesta.data.SiHayError)
                  {
                      comun.SeEstaCargandoInformacion(false);
                      console.log(respuesta);
                      comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);

                      this.Etiqueta = respuesta.data.Error.Mensaje;
                      this.ShowInfoDocumento = false;
                  }
                  else
                  {
                      comun.SeEstaCargandoInformacion(false);
                      this.Etiqueta = respuesta.data.Satisfactorio;
                      this.BusquedaCodigo = this.Documento.CodigoBarras;
                      
                      this.ListaVolumenes = [];
                      this.ListaIncidentes=[];
                      this.BusquedaDocumento();
                      this.ShowInfoDocumento = true;
                      this.SeleccionarTodos = false;
                      this.ObtenerPublicoJuzgado();

                  }
                  comun.SeEstaCargandoInformacion(false);

              })
              .catch(excepcion => {
                  console.log(excepcion);
                  console.log("fallo por parametros");
                  comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  comun.SeEstaCargandoInformacion(false);
                  this.BusquedaCodigo = "";
              })
            }
        },
        VerificarVolumenes(areaId){
            var volumenesEnJuzgado = [];
            var datos = Object;
            var Ubicacion = "";
            $.each(this.Volumenes, function(indice, volumen)
            {

            if(volumen.EstatusVolumenes.TipoEstatusVolumenId == enumeraciones.TipoEstatusVolumen.NoDisponible &&
                volumen.Area.AreaId == areaId )
                {
                    volumenesEnJuzgado.push(volumen);
                }
                else{
                    Ubicacion = volumen.Area.Nombre;
                }
            });
            
          datos = {"Ubicacion": Ubicacion, "Volumenes": volumenesEnJuzgado}
          return datos;  
        },
        VerificaIncidentes(areaId){
          var incidentesEnJuzgado = [];
          var datos = Object;
          var Ubicacion ="";
          $.each(this.Incidentes, function(indice, incidente)
            {

            if(incidente.EstatusVolumenes.TipoEstatusVolumenId == enumeraciones.TipoEstatusVolumen.NoDisponible &&
                incidente.Area.AreaId == areaId )
                {
                    incidentesEnJuzgado.push(incidente);
                }
                else{
                    Ubicacion = incidente.Area.Nombre;
                }
            });
          datos = {"Ubicacion": Ubicacion, "Incidentes": incidentesEnJuzgado}
          return datos;
        },
        SeleccionarVolumenes(){
            let VolumenesEnSolicitud = [];
            this.ListaVolumenes.forEach((element) =>{
                let AgregaVol = this.volumenesJuzgado.find(vol =>vol.VolumenId == element);
                VolumenesEnSolicitud.push(
                    AgregaVol)
            });
            return VolumenesEnSolicitud;
        },
        SeleccionarIncidentes(){
          let IncidentesEnSolicitud =[];
          this.ListaIncidentes.forEach((element)=> {
            let agregarIncidente = this.incidentesJuzgado.find(inc=>inc.IncidenteId == element);
            IncidentesEnSolicitud.push(agregarIncidente);
          });
          return IncidentesEnSolicitud;
        },
        SelectAll(){
            this.ListaVolumenes = [];
            if(this.SeleccionarTodos == false)
            {
                for (let i in this.volumenesJuzgado)
                {
                    this.ListaVolumenes.push(this.volumenesJuzgado[i].VolumenId)
                }
            };
            

        },
        ObtenerPublicoJuzgado(){
            var peticion = {
                "CodigoBarras" : this.BusquedaCodigo
            };
            axios.post(api.conexion + api.ArchivoJudicial.ListadoDePublicos, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.BusquedaCodigo = "";
                    //this.ShowInfoDocumento = false;
                 }
                else
                {
                    comun.SeEstaCargandoInformacion(false);
                    this.BusquedaCodigo = "";
                    var ListaPreliminar = [];
                    var temp = [];
                    ListaPreliminar = respuesta.data.MovimientosDocumentosPublicos;//!=null? respuesta.data.MovimientosDocumentosPublicos: this.ListaDePublicos = [];
                    temp = respuesta.data.MovimientosIncidentesPublicos;
                    
                    if(temp.length>0)
                    {
                       $.each(temp, function(index, incidente)
                       {
                         ListaPreliminar.push(incidente);
                       });
                    }
                    var ListadoConFormato = [];
                    ListadoConFormato = this.DarFormatoListado(ListaPreliminar);
                    
                    this.ListaDePublicos= this.AgruparInventarioDocumentoId(ListadoConFormato);
                }
                comun.SeEstaCargandoInformacion(false);

            })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                this.BusquedaCodigo = "";
            })
        },
        AgruparInventarioDocumentoId(datos){
        var ListaInicial=[];
        $.each(datos, function(index, listado){
          var chequeo = ListaInicial.find(e=>e.InventarioDocumentoId == listado.InventarioDocumentoId);
          if(chequeo == undefined || chequeo == false)
          {
            ListaInicial.push({"InventarioDocumentoId": listado.InventarioDocumentoId,
                              "TipoDocumento": listado.TipoDocumento,
                              "Anio": listado.Anio,
                              "Consecutivo": listado.Consecutivo,
                              "SedeArchivo": listado.SedeArchivo,
                              "Movimientos": [
                                {
                                  "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                  "FechaMovimiento": listado.FechaMovimiento,
                                  "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                  "AreaQuePresta": listado.AreaQuePresta,
                                  "IncidenteId": listado.IncidenteId,
                                  "Incidente": listado.Incidente!= null? listado.Incidente : null,
                                  "VolumenId": listado.VolumenId,
                                  "Volumen": listado.Volumen!=null ? listado.Volumen : null,
                                  "TiposMovimientos": listado.TiposMovimientos,
                                  "FechaRecepcion":listado.FechaRecepcion
                                }],
                              "Observaciones": listado.Observaciones});
          }
          else{
            chequeo.Movimientos.push({
                                  "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                                  "FechaMovimiento": listado.FechaMovimiento,
                                  "UsuarioQuienPresta": listado.UsuarioQuienPresta,
                                  "AreaQuePresta": listado.AreaQuePresta,
                                  "IncidenteId": listado.IncidenteId,
                                  "Incidente": listado.Incidente!= null? listado.Incidente : null,
                                  "VolumenId": listado.VolumenId,
                                  "Volumen": listado.Volumen!=null ? listado.Volumen : null,
                                  "TiposMovimientos": listado.TiposMovimientos,
                                  "FechaRecepcion":listado.FechaRecepcion});
          }
        });
        return ListaInicial;
        },
        DarFormatoListado(Lista){
          
          var ListaPreliminar =[];
          $.each(Lista, function (index, movIds){
              ListaPreliminar.push(
                {
                  "MovimientoDocumentoId": movIds.MovimientoDocumentoId,
                  "InventarioDocumentoId": movIds.VolumenId !=null ? movIds.Volumen.InventarioDocumentoId : movIds.Incidente.InventarioDocumentoId,
                  "TipoDocumento": movIds.VolumenId !=null ? movIds.Volumen.Inventario.TipoDocumento : movIds.Incidente.Inventario.TipoDocumento,
                  "Anio": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Anio : movIds.Incidente.Inventario.Anio,
                  "Consecutivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.Consecutivo : movIds.Incidente.Inventario.Consecutivo,
                  "AreaQuePresta": movIds.AreaQuePresta,
                  "UsuarioQuienPresta": movIds.UsuarioQuienPresta,
                  "FechaMovimiento": movIds.FechaMovimiento,
                  "VolumenId": movIds.VolumenId,
                  "Volumen": movIds.Volumen,
                  "IncidenteId": movIds.IncidenteId,
                  "Incidente": movIds.Incidente,
                  "TerceriaId": movIds.TerceriaId,
                  "Terceria": movIds.Terceria,
                  "SedeArchivo": movIds.VolumenId !=null ? movIds.Volumen.Inventario.SedeArchivo : movIds.Incidente.Inventario.SedeArchivo,
                  "Observaciones": movIds.Observaciones,
                  "TiposMovimientos": movIds.TiposMovimientos,
                  "FechaRecepcion": movIds.FechaRecepcion
                })
            
          });
          
          return ListaPreliminar;
        },
        DesglosaContenido: function (datos){
            let Contenido ="";
            if(datos.AnexosVolumen.length>0)
            {
                Contenido= Contenido +"<b class='text-primary'>ANEXOS</b><br/>";
                    $.each(datos.AnexosVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "Cantidad: "+ enVolumen.Cantidad + ",  Observaciones: " + enVolumen.Observaciones + "<br/>";
                    })
            };
            if(datos.AmparosVolumen.length>0)
            {
              Contenido= Contenido +"<b class='text-primary'>AMPAROS</b><br/>";
                    $.each(datos.AmparosVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "Consecutivo: "+ enVolumen.Consecutivo + ",  Observaciones: " + (enVolumen.Observaciones!=null ? enVolumen.Observaciones : "Ninguna" ) + "<br/>";
                    })
            };
            if(datos.IncidenteVolumen.length>0)
                {
                  Contenido = Contenido +"<b class='text-primary'>INCIDENTES</b><br/>";
                    $.each(datos.IncidenteVolumen, function(index, enVolumen)
                    {
                    Contenido = Contenido + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    })
                }
            return Contenido;
        }
    },
    created(){
        this.ObtenerPublicoJuzgado();
    }
}
</script>

<style scoped>
  input[type="text"]:read-only {
    background: #504f54;
  }

    input[type="text"]:read-only:focus {
      color: #fff;
    }

  #modalSolicitud {
    overflow-y: auto;
    max-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/NuevaSolicitudPublicaJuzgado.vue